import { TranslationKeys } from "./en";

export const da: TranslationKeys = {
  common: {
    save: "Gem",
    cancel: "Annuller",
    delete: "Slet",
    edit: "Rediger",
    loading: "Indlæser...",
    error: "Fejl",
    success: "Succes",
    confirm: "Bekræft",
    back: "Tilbage",
    next: "Næste",
    done: "Færdig",
    search: "Søg",
    noResults: "Ingen resultater fundet",
    viewAll: "Se alle",
    seeMore: "Se mere",
    close: "Luk",
    retry: "Prøv igen",
    share: "Del",
    copy: "Kopier",
    signOut: "Log ud",
    or: "eller",
    and: "og",
    yes: "Ja",
    no: "Nej",
    optional: "Valgfri",
    required: "Påkrævet",
    submit: "Indsend",
    update: "Opdater",
    create: "Opret",
    add: "Tilføj",
    remove: "Fjern",
    filter: "Filtrer",
    sort: "Sortér",
    all: "Alle",
    none: "Ingen",
    select: "Vælg",
    selected: "valgt",
    showing: "Viser",
    of: "af",
    to: "til",
    from: "fra",
  },
  nav: {
    dashboard: "Oversigt",
    feed: "Feed",
    workout: "Træning",
    templates: "Skabeloner",
    leaderboard: "Rangliste",
    analytics: "Statistik",
    achievements: "Præstationer",
    premium: "Premium",
    friends: "Venner",
    profile: "Profil",
    notifications: "Notifikationer",
    settings: "Indstillinger",
    support: "Support",
    logout: "Log ud",
    more: "Mere",
    newWorkout: "Ny træning",
    home: "Hjem",
    admin: "Admin",
  },
  auth: {
    welcome: "Velkommen",
    signIn: "Log ind",
    signUp: "Opret konto",
    signInDescription: "Log ind på din konto",
    signUpDescription: "Opret en ny konto for at komme i gang",
    signInOrCreateAccount: "Log ind eller opret en konto for at komme i gang",
    email: "E-mail",
    password: "Adgangskode",
    username: "Brugernavn",
    usernamePlaceholder: "dit_brugernavn",
    passwordPlaceholder: "Mindst 12 tegn",
    forgotPassword: "Glemt adgangskode?",
    resetPassword: "Nulstil adgangskode",
    resetPasswordDesc: "Indtast din e-mailadresse, så sender vi dig et link til at nulstille din adgangskode.",
    resetPasswordDescription: "Indtast din e-mailadresse, så sender vi dig et link til at nulstille din adgangskode.",
    sendResetLink: "Send nulstillingslink",
    setNewPassword: "Angiv ny adgangskode",
    confirmPassword: "Bekræft adgangskode",
    confirmNewPassword: "Bekræft ny adgangskode",
    confirmNewPasswordBtn: "Bekræft ny adgangskode",
    confirmYourPassword: "Bekræft din nye adgangskode",
    newPassword: "Ny adgangskode",
    enterNewPassword: "Indtast din nye adgangskode",
    enterNewPasswordBelow: "Indtast din nye adgangskode nedenfor",
    createAccount: "Opret konto",
    alreadyHaveAccount: "Har du allerede en konto?",
    dontHaveAccount: "Har du ikke en konto?",
    signingIn: "Logger ind...",
    creatingAccount: "Opretter konto...",
    sending: "Sender...",
    updating: "Opdaterer...",
    passwordRequirements: "Skal indeholde mindst 12 tegn, inklusiv stort bogstav, lille bogstav, tal og specialtegn",
    passwordHint: "Skal indeholde stort bogstav, lille bogstav, tal og specialtegn",
    emailVerified: "E-mail bekræftet!",
    emailVerifiedDesc: "Din e-mail er blevet bekræftet.",
    checkEmail: "Tjek din e-mail for bekræftelseslinket",
    checkYourEmail: "Tjek din e-mail!",
    resetLinkSent: "Vi har sendt dig et link til at nulstille din adgangskode.",
    failedToSendReset: "Kunne ikke sende nulstillingslink",
    accountCreated: "Konto oprettet!",
    welcomeMessage: "Velkommen til FITLINK! Lad os komme i gang.",
    welcomeToFitlink: "Velkommen til FITLINK! Lad os komme i gang.",
    loginFailed: "Login fejlede",
    signupFailed: "Oprettelse fejlede",
    usernameTaken: "Dette brugernavn er allerede taget. Vælg venligst et andet.",
    passwordsDontMatch: "Adgangskoderne matcher ikke",
    passwordsDontMatchDesc: "Sørg for at begge adgangskoder matcher.",
    passwordUpdated: "Adgangskode opdateret!",
    passwordUpdatedDesc: "Din adgangskode er blevet nulstillet.",
    passwordRequirementsNotMet: "Adgangskodekrav ikke opfyldt",
    missingCredentials: "Manglende oplysninger",
    enterEmail: "Indtast venligst din e-mail",
    enterPassword: "Indtast venligst din adgangskode",
    accountLocked: "Konto midlertidigt låst",
    tooManyAttempts: "For mange forsøg",
    tryAgainLater: "Prøv venligst igen senere.",
    serviceUnavailable: "Tjeneste midlertidigt utilgængelig",
    serviceUnavailableDesc: "Kunne ikke verificere. Prøv venligst igen om et øjeblik.",
    privacyNotice: "Privatlivsbeskyttelse",
    privacyDescription: "Vi indsamler dine træningsdata for at give personlige fitness-anbefalinger.",
    dataCollection: "Data vi indsamler",
    dataPrivacy: "Databeskyttelse",
    dataPrivacyDesc: "Vi indsamler dine træningsdata og profiloplysninger for at give personlig fitness-tracking.",
    agreeToTerms: "Ved at tilmelde dig accepterer du vores",
    termsAndPrivacy: "Servicevilkår og Privatlivspolitik",
    termsOfUse: "Brugsvilkår",
    privacyPolicy: "Privatlivspolitik",
    stayFitStayLinked: "Hold dig i form, hold forbindelsen.",
    tagline: "Hold dig i form, hold forbindelsen.",
    verificationEmailSent: "Vi har sendt dig en bekræftelsesmail. Tjek venligst din indbakke og klik på linket for at bekræfte din konto.",
    fullName: "Fuldt navn",
  },
  settings: {
    title: "Indstillinger",
    description: "Administrer dine app-præferencer og data",
    appearance: "Udseende",
    darkMode: "Mørk tilstand",
    lightMode: "Lys tilstand",
    themeDescription: "Skift mellem lyst og mørkt tema",
    language: "Sprog",
    languageDescription: "Vælg dit foretrukne sprog",
    saveReload: "Gem og genindlæs",
    profileManagement: "Profilhåndtering",
    personalInfo: "Personlige oplysninger",
    personalInfoDescription: "Opdater dine personlige detaljer for AI-anbefalinger",
    editPersonalInfo: "Rediger personlige oplysninger",
    goalsExperience: "Mål og erfaring",
    goalsDescription: "Opdater dine fitnessmål og erfaringsniveau",
    updateGoals: "Opdater mål",
    subscription: "Abonnement",
    manageSubscription: "Administrer abonnement",
    updatePayment: "Opdater betaling eller annuller plan",
    legalPrivacy: "Juridisk og privatliv",
    legalDescription: "Gennemgå vores politikker og vilkår",
    termsOfUse: "Vilkår for brug",
    privacyPolicy: "Privatlivspolitik",
    dangerZone: "Farezone",
    dangerDescription: "Slet permanent alle dine træningsdata, PRer, præstationer og statistikker",
    resetStatistics: "Nulstil alle statistikker",
    deleteAccount: "Slet konto",
    resetConfirmTitle: "Nulstil alle statistikker?",
    resetConfirmDescription: "Denne handling kan ikke fortrydes. Dette vil permanent slette:",
    resetConfirmList: {
      workouts: "Al din træningshistorik",
      exercises: "Alle øvelsesregistreringer",
      prs: "Alle personlige rekorder (PRer)",
      achievements: "Alle præstationer og badges",
      streaks: "Alle træningsserier",
    },
    resetConfirmWarning: "Er du helt sikker på, at du vil fortsætte?",
    resetButton: "Ja, nulstil alt",
    resetting: "Nulstiller...",
    deleteConfirmTitle: "Slet konto permanent?",
    deleteWarning: "Denne handling er PERMANENT og kan IKKE fortrydes!",
    deleteConfirmList: {
      workouts: "Alle træninger og øvelseshistorik",
      achievements: "Alle præstationer og personlige rekorder",
      friends: "Alle venner og sociale forbindelser",
      photos: "Alle fotos og check-in data",
      profile: "Din profil og kontoinformation",
      subscription: "Dit abonnement (hvis aktivt)",
    },
    typeDelete: "Skriv DELETE for at bekræfte:",
    deleting: "Sletter...",
    deleteButton: "Slet konto permanent",
  },
  toast: {
    saved: "Ændringer gemt",
    deleted: "Slettet",
    error: "Noget gik galt",
    copied: "Kopieret til udklipsholder",
    signedOut: "Logget ud",
    workoutDeleted: "Træning slettet",
    workoutSaved: "Træning gemt",
    templateSaved: "Skabelon gemt!",
    templateDeleted: "Skabelon slettet",
    preferencesUpdated: "Præferencer opdateret",
    friendRequestSent: "Venneanmodning sendt",
    friendRequestAccepted: "Venneanmodning accepteret!",
    profileUpdated: "Profil opdateret",
  },
  workout: {
    title: "Træning",
    startWorkout: "Start træning",
    finishWorkout: "Afslut træning",
    saveWorkout: "Gem træning",
    addExercise: "Tilføj øvelse",
    sets: "Sæt",
    reps: "Gentagelser",
    weight: "Vægt",
    notes: "Noter",
    rest: "Hvile",
    noExercises: "Ingen øvelser tilføjet endnu",
    duration: "Varighed",
    calories: "Kalorier",
    description: "Beskrivelse",
    private: "Privat",
    public: "Offentlig",
    trackDuration: "Spor varighed",
    manualDuration: "Manuel varighed",
    exercisePlaceholder: "Tilføj din første øvelse for at komme i gang",
    saveAsTemplate: "Gem som skabelon",
    loadTemplate: "Indlæs skabelon",
    doAgain: "Gentag",
    analyze: "AI-analyse",
    deleteConfirm: "Slet træning?",
    deleteConfirmDescription: "Denne handling kan ikke fortrydes.",
    kg: "kg",
    lbs: "lbs",
    minutes: "minutter",
    hours: "timer",
    seconds: "sekunder",
    set: "Sæt",
    exercise: "Øvelse",
    exercises: "Øvelser",
    completed: "Fuldført",
    inProgress: "I gang",
    paused: "Pauset",
    resume: "Genoptag",
    pause: "Pause",
    stop: "Stop",
    restTimer: "Hviletimer",
    skipRest: "Spring hvile over",
    addSet: "Tilføj sæt",
    removeSet: "Fjern sæt",
    superset: "Supersæt",
    createSuperset: "Opret supersæt",
    personalRecord: "Personlig rekord",
    newPR: "Ny PR!",
    previousBest: "Tidligere bedste",
    selectExercise: "Vælg øvelse",
    searchExercises: "Søg øvelser...",
    recentExercises: "Seneste øvelser",
    allExercises: "Alle øvelser",
    customExercise: "Brugerdefineret øvelse",
    addCustomExercise: "Tilføj brugerdefineret øvelse",
    targetMuscles: "Målmuskler",
    techniqueTips: "Tekniktips",
    commonMistakes: "Almindelige fejl",
    history: "Historik",
    noHistory: "Ingen historik tilgængelig",
    tagFriends: "Tag venner",
    shareWorkout: "Del træning",
    copyWorkout: "Kopier træning",
    workoutComplete: "Træning fuldført!",
    greatJob: "Godt arbejde!",
    summary: "Oversigt",
    totalVolume: "Samlet volumen",
    totalSets: "Samlede sæt",
    totalReps: "Samlede gentagelser",
  },
  dashboard: {
    title: "Oversigt",
    welcome: "Velkommen tilbage",
    todayWorkout: "Dagens træning",
    weeklyProgress: "Ugentlig fremgang",
    recentActivity: "Seneste aktivitet",
    quickActions: "Hurtige handlinger",
    noWorkouts: "Ingen træninger endnu",
    startFirst: "Start din første træning!",
    pullToRefresh: "Træk for at opdatere",
    loadMore: "Indlæs flere",
    communityFeed: "Fællesskabsfeed",
    yourFeed: "Dit feed",
    announcements: "Meddelelser",
    noActivity: "Ingen seneste aktivitet",
    startWorking: "Begynd at træne for at se din fremgang her!",
    streak: "Serie",
    days: "dage",
    thisWeek: "Denne uge",
    personalRecords: "Personlige rekorder",
    weeklyGoal: "Ugentligt mål",
    workoutsThisWeek: "træninger denne uge",
    activity: "Aktivitet",
    upgradeToPremium: "Opgrader til Premium",
    unlockFeatures: "Lås op for statistik, rangliste og analyse",
    beFirstToLog: "Vær den første til at logge en træning og del med fællesskabet!",
    logFirstWorkout: "Log din første træning",
    doLiveWorkout: "Start live træning",
    editWorkout: "Rediger træning",
    moreExercises: "mere",
    showLess: "Vis mindre",
    aiWorkoutAnalysis: "AI træningsanalyse",
    aiAnalysisDescription: "Få AI-drevne indsigter om præstation, formtips og forbedringsforslag. Premium funktion.",
    loadingMore: "Indlæser flere træninger...",
    endOfFeed: "Du har nået slutningen af feedet",
    workoutTitle: "Træningstitel",
    workoutTitlePlaceholder: "Min fantastiske træning",
    descriptionPlaceholder: "Beskriv din træning...",
    saveChanges: "Gem ændringer",
    withFriends: "med venner",
  },
  profile: {
    title: "Profil",
    editProfile: "Rediger profil",
    followers: "Følgere",
    following: "Følger",
    workouts: "Træninger",
    joined: "Tilmeldt",
    yourGoals: "Dine mål",
    fitnessGoal: "Fitnessmål",
    experienceLevel: "Erfaringsniveau",
    weeklyCheckIn: "Ugentlig check-in",
    workoutHistory: "Træningshistorik",
    checkIns: "Check-ins",
    upgradePremium: "Opgrader til Premium",
    unlockFeatures: "Lås op for statistik, rangliste og analyse",
    viewPlans: "Se planer",
    bio: "Biografi",
    fullName: "Fulde navn",
    dateOfBirth: "Fødselsdato",
    height: "Højde",
    currentWeight: "Nuværende vægt",
    gender: "Køn",
    male: "Mand",
    female: "Kvinde",
    other: "Andet",
    preferNotToSay: "Foretrækker ikke at sige",
    saveChanges: "Gem ændringer",
    noGoalsSet: "Ingen mål sat endnu",
    setGoals: "Sæt dine fitnessmål",
    memberSince: "Medlem siden",
    totalWorkouts: "Samlede træninger",
    currentStreak: "Nuværende serie",
    longestStreak: "Længste serie",
    verified: "Verificeret",
    statisticsReset: "Statistik nulstillet",
    statisticsResetDesc: "Alle dine træningsdata er blevet slettet.",
    resetFailed: "Kunne ikke nulstille statistik. Prøv igen.",
    goalsUpdated: "Mål opdateret!",
    goalsUpdatedDesc: "Dine fitnessmål og erfaringsniveau er blevet opdateret.",
    goals: {
      buildMuscle: "Byg muskler",
      loseWeight: "Tab vægt",
      getStronger: "Bliv stærkere",
      improveEndurance: "Forbedre udholdenhed",
      stayActive: "Hold dig aktiv",
      athleticPerformance: "Atletisk præstation",
    },
  },
  achievements: {
    title: "Præstationer",
    unlocked: "Låst op",
    locked: "Låst",
    progress: "Fremgang",
    keepGoing: "Bliv ved!",
    newUnlock: "Ny præstation låst op!",
    milestone: "Milepæl",
    strength: "Styrke",
    consistency: "Konsistens",
    social: "Social",
    variety: "Variation",
    volume: "Volumen",
    all: "Alle",
    earned: "Optjent",
    unearned: "Ikke optjent endnu",
    congratulations: "Tillykke!",
    youEarned: "Du optjente",
    shareAchievement: "Del præstation",
    viewAll: "Se alle præstationer",
    recentlyUnlocked: "Nyligt låst op",
  },
  friends: {
    title: "Venner",
    addFriend: "Tilføj ven",
    searchUsers: "Søg efter brugere...",
    pending: "Afventer",
    accepted: "Venner",
    noFriends: "Ingen venner endnu",
    sendRequest: "Send anmodning",
    acceptRequest: "Accepter",
    declineRequest: "Afvis",
    removeFriend: "Fjern ven",
    friendRequests: "Venneanmodninger",
    myFriends: "Mine venner",
    suggestions: "Forslag",
    noRequests: "Ingen ventende anmodninger",
    requestSent: "Anmodning sendt!",
    requestAccepted: "Anmodning accepteret!",
    requestDeclined: "Anmodning afvist",
    friendRemoved: "Ven fjernet",
    mutualFriends: "fælles venner",
    viewProfile: "Se profil",
    message: "Besked",
  },
  premium: {
    title: "Premium",
    upgrade: "Opgrader",
    features: "Premium-funktioner",
    monthly: "Månedlig",
    yearly: "Årlig",
    currentPlan: "Nuværende plan",
    subscribe: "Abonner",
    restore: "Gendan køb",
    perMonth: "/måned",
    perYear: "/år",
    savePercent: "Spar",
    mostPopular: "Mest populær",
    freePlan: "Gratis plan",
    premiumPlan: "Premium plan",
    includesFeatures: "Inkluderer alle funktioner",
    unlockAll: "Lås alle funktioner op",
    alreadyPremium: "Du er allerede premium-medlem!",
    manageSubscription: "Administrer abonnement",
    cancelAnytime: "Annuller når som helst",
    startFreeTrial: "Start gratis prøveperiode",
    trialDays: "dages gratis prøveperiode",
    bestValue: "Bedste værdi",
    billedAnnually: "Faktureres årligt",
    billedMonthly: "Faktureres månedligt",
    featuresList: {
      analytics: "Avanceret statistik og indsigt",
      leaderboard: "Adgang til fitness-rangliste",
      aiAnalysis: "AI-træningsanalyse",
      templates: "Ubegrænsede skabeloner",
      checkIns: "Ugentlige check-ins med fotos",
      exportData: "Eksporter dine data",
      prioritySupport: "Prioriteret support",
      noAds: "Reklamefri oplevelse",
    },
  },
  templates: {
    title: "Skabeloner",
    create: "Opret skabelon",
    edit: "Rediger skabelon",
    delete: "Slet skabelon",
    myTemplates: "Mine skabeloner",
    publicTemplates: "Offentlige skabeloner",
    noTemplates: "Ingen skabeloner endnu",
    createFirst: "Opret din første skabelon",
    templateName: "Skabelonnavn",
    templateDescription: "Beskrivelse",
    category: "Kategori",
    makePublic: "Gør offentlig",
    publicDescription: "Tillad andre premium-brugere at se og bruge denne skabelon",
    addExercise: "Tilføj øvelse",
    saveTemplate: "Gem skabelon",
    useTemplate: "Brug skabelon",
    startWorkout: "Start træning",
    exercises: "øvelser",
    createdBy: "Oprettet af",
    generateWithAI: "Generer med AI",
    aiPromptPlaceholder: "Beskriv den træning, du ønsker (f.eks. 'overkropsstyrketræning for begyndere')...",
    generating: "Genererer...",
    categories: {
      all: "Alle",
      beginner: "Begynder",
      advanced: "Avanceret",
      strength: "Styrke",
      hypertrophy: "Hypertrofi",
      endurance: "Udholdenhed",
      general: "Generel",
    },
  },
  analytics: {
    title: "Statistik",
    overview: "Oversigt",
    volume: "Volumen",
    strength: "Styrke",
    progression: "Progression",
    calendar: "Kalender",
    period: "Periode",
    week: "Uge",
    month: "Måned",
    year: "År",
    totalWorkouts: "Samlede træninger",
    totalVolume: "Samlet volumen",
    avgVolume: "Gns. volumen",
    personalRecords: "Personlige rekorder",
    muscleGroups: "Muskelgrupper",
    volumeOverTime: "Volumen over tid",
    strengthProgress: "Styrkefremgang",
    workoutCalendar: "Træningskalender",
    noData: "Ingen data tilgængelig",
    startTracking: "Begynd at spore dine træninger for at se statistik",
    comparedToPrevious: "sammenlignet med forrige periode",
    improvement: "forbedring",
    decline: "tilbagegang",
    noChange: "ingen ændring",
    exerciseTrends: "Øvelsestendenser",
    plateauDetection: "Plateaudetektion",
    injuryRisk: "Skaderisiko-vurdering",
    fitnessScore: "Fitnessscore",
    restDays: "Hviledage",
    prRate: "PR-rate",
    bestDay: "Bedste dag",
    volumeVelocity: "Volumenhastighed",
    filters: {
      muscleGroup: "Muskelgruppe",
      exerciseType: "Øvelsestype",
      all: "Alle",
      chest: "Bryst",
      back: "Ryg",
      legs: "Ben",
      shoulders: "Skuldre",
      arms: "Arme",
      cardio: "Cardio",
      strength: "Styrke",
    },
  },
  notifications: {
    title: "Notifikationer",
    markAllRead: "Markér alle læst",
    deleteAll: "Slet alle",
    noNotifications: "Ingen notifikationer endnu",
    preferences: "Notifikationsindstillinger",
    types: {
      like: "Like",
      comment: "Kommentar",
      friendRequest: "Venneanmodning",
      friendAccepted: "Ven accepteret",
      personalRecord: "Personlig rekord",
      workoutTag: "Trænings-tag",
      announcement: "Meddelelse",
    },
    settings: {
      likes: "Likes",
      likesDescription: "Når nogen liker din træning",
      comments: "Kommentarer",
      commentsDescription: "Når nogen kommenterer på din træning",
      friendRequests: "Venneanmodninger",
      friendRequestsDescription: "Når nogen sender dig en venneanmodning",
      friendAccepted: "Ven accepteret",
      friendAcceptedDescription: "Når nogen accepterer din venneanmodning",
      personalRecords: "Personlige rekorder",
      personalRecordsDescription: "Når du opnår en ny personlig rekord",
      workoutTags: "Trænings-tags",
      workoutTagsDescription: "Når nogen tagger dig i en træning",
    },
    deleteAllConfirm: "Slet alle notifikationer?",
    deleteAllDescription: "Dette vil permanent slette alle notifikationer. Denne handling kan ikke fortrydes.",
    allMarkedRead: "Alle notifikationer markeret som læst",
    allDeleted: "Alle notifikationer slettet",
  },
  support: {
    title: "Supportcenter",
    contactUs: "Kontakt os",
    contactDescription: "Brug for hjælp? Vores supportteam er her for dig.",
    emailSupport: "E-mail support",
    responseTime: "Vi svarer typisk inden for 24 timer",
    submitTicket: "Indsend supportsag",
    faq: "FAQ",
    frequentlyAsked: "Ofte stillede spørgsmål",
    privacyPolicy: "Privatlivspolitik",
    privacyDescription: "Læs hvordan vi beskytter og håndterer dine data",
    accountDeletion: "Kontosletning",
    accountDeletionDescription: "Instruktioner til permanent sletning af din konto",
    goToSettings: "Gå til indstillinger",
    faqs: {
      cancelSubscription: {
        question: "Hvordan annullerer jeg mit abonnement?",
        answer: "Du kan administrere dit abonnement gennem dine kontoindstillinger. For webabonnementer, brug kundeportalen. For iOS-abonnementer, gå til Indstillinger > [Dit navn] > Abonnementer på din iPhone.",
      },
      deleteAccount: {
        question: "Hvordan sletter jeg min konto?",
        answer: "Du kan slette din konto fra Indstillinger-dialogen i appen. Dette vil permanent slette alle dine data, inklusiv træninger, fremskridtsbilleder og personlige rekorder.",
      },
      dataAfterDeletion: {
        question: "Hvad sker der med mine data efter kontosletning?",
        answer: "Alle dine data slettes permanent fra vores servere, inklusiv træninger, fotos, præstationer og personlige oplysninger. Denne handling kan ikke fortrydes.",
      },
      restorePurchase: {
        question: "Hvordan gendanner jeg mit Apple In-App køb?",
        answer: "Gå til Premium-siden i appen og tryk på 'Gendan køb'-knappen. Sørg for, at du er logget ind med det samme Apple ID, som blev brugt til det originale køb.",
      },
      exportData: {
        question: "Kan jeg eksportere mine træningsdata?",
        answer: "Premium-brugere kan eksportere deres træningshistorik fra Statistik-siden. Gratis brugere kan kontakte support for dataeksportanmodninger.",
      },
    },
  },
  leaderboard: {
    title: "Rangliste",
    rank: "Placering",
    user: "Bruger",
    score: "Score",
    fitnessScore: "Fitnessscore",
    weeklyVolume: "Ugentlig volumen",
    monthlyWorkouts: "Månedlige træninger",
    totalPRs: "Samlede PRer",
    yourRank: "Din placering",
    top10: "Top 10",
    friends: "Venner",
    friendsRanking: "Venners rangliste",
    global: "Global",
    globalRanking: "Globale placeringer",
    noData: "Ingen rangliste-data tilgængelig",
    period: "Periode",
    metric: "Metrik",
  },
  time: {
    justNow: "Lige nu",
    minutesAgo: "m siden",
    hoursAgo: "t siden",
    daysAgo: "d siden",
    weeksAgo: "u siden",
    monthsAgo: "md siden",
    yearsAgo: "å siden",
    today: "I dag",
    yesterday: "I går",
    thisWeek: "Denne uge",
    lastWeek: "Sidste uge",
    thisMonth: "Denne måned",
    lastMonth: "Sidste måned",
  },
  errors: {
    somethingWentWrong: "Noget gik galt",
    tryAgain: "Prøv venligst igen",
    networkError: "Netværksfejl. Tjek venligst din forbindelse.",
    notFound: "Ikke fundet",
    unauthorized: "Du har ikke tilladelse til at udføre denne handling",
    forbidden: "Adgang nægtet",
    serverError: "Serverfejl. Prøv venligst igen senere.",
    validationError: "Valideringsfejl",
    requiredField: "Dette felt er påkrævet",
    invalidEmail: "Indtast venligst en gyldig e-mailadresse",
    invalidPassword: "Adgangskoden opfylder ikke kravene",
    passwordTooShort: "Adgangskoden skal være mindst 12 tegn",
    usernameTaken: "Dette brugernavn er allerede taget",
    emailTaken: "Denne e-mail er allerede registreret",
    invalidCredentials: "Ugyldig e-mail eller adgangskode",
    sessionExpired: "Din session er udløbet. Log venligst ind igen.",
    rateLimited: "For mange forsøg. Prøv venligst igen senere.",
    serviceUnavailable: "Tjenesten er midlertidigt utilgængelig. Prøv venligst igen om et øjeblik.",
  },
  landing: {
    hero: "Spor din fitnessrejse",
    tagline: "Den ultimative træningspartner til at spore fremgang, forbinde med venner og nå dine fitnessmål.",
    getStarted: "Kom i gang",
    learnMore: "Læs mere",
    features: {
      trackProgress: {
        title: "Spor fremgang",
        description: "Log træninger, spor personlige rekorder og visualiser din forbedring over tid.",
      },
      socialFeed: {
        title: "Socialt feed",
        description: "Del præstationer, hep på venner og forbliv motiveret sammen.",
      },
      achieveGoals: {
        title: "Opnå mål",
        description: "Sæt fitnessmål, lås op for præstationer og fejr hver milepæl.",
      },
    },
  },
};
